import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { classicProjectSettingsSoftwareRedirectRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/classicProjectSettingsSoftwareRedirectRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	RedirectForSettingsForClassicProject,
	getSettingsNavigationResources,
} from './ui/project-settings/product-routes/common/index.tsx';

export const classicProjectSettingsSoftwareRedirectRouteEntry: Route = createEntry(
	classicProjectSettingsSoftwareRedirectRoute,

	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: RedirectForSettingsForClassicProject,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
